import { useDispatch, useSelector } from "react-redux";
import { setAuth, clearAuth, selectRole, selectDashboardRoute } from "../store/auth";
import { postDataTo } from "../_helper/fetcher";
import { RoleUtils, ROLES } from "../constants/roles";

export function useAuth() {
  const dispatch = useDispatch();
  const userRole = useSelector(selectRole);
  const dashboardRoute = useSelector(selectDashboardRoute);

  async function handleLogin(body) {
    try {
      const res = await postDataTo("login", body);
      if (res.token && res.user) {
        const user = res.user;
        const permissions = user.role?.permissions || [];
        
        const authBody = {
          userId: user.id,
          permissions: permissions,
          name: user.name,
          email: user.email,
          token: res.token,
          isSuperAdmin: permissions[0] === "*",
          authorized: true,
        };
        
        localStorage.setItem("acstkn", res.token);
        dispatch(setAuth(authBody));
        
        return { 
          success: true, 
          role: RoleUtils.getRoleFromPermissions(permissions),
          dashboardRoute: RoleUtils.getDashboardRoute(RoleUtils.getRoleFromPermissions(permissions))
        };
      }
      
      throw new Error("Invalid login response");
    } catch (error) {
      throw error;
    }
  }

  async function logout() {
    try {
      await postDataTo("logout");
    } catch (error) {
      // Continue with logout even if API call fails
      console.warn("Logout API call failed:", error);
    } finally {
      localStorage.removeItem("acstkn");
      dispatch(clearAuth());
    }
  }

  /**
   * Get appropriate dashboard route for current user role
   * @returns {string} Dashboard route
   */
  function getDashboard() {
    return dashboardRoute;
  }

  /**
   * Check if current user has specific role
   * @param {string} role - Role to check
   * @returns {boolean}
   */
  function hasRole(role) {
    return RoleUtils.hasRole(userRole, role);
  }

  /**
   * Check if current user has role or higher
   * @param {string} role - Minimum role required
   * @returns {boolean}
   */
  function hasRoleOrHigher(role) {
    return RoleUtils.hasRoleOrHigher(userRole, role);
  }

  return {
    handleLogin,
    logout,
    getDashboard,
    hasRole,
    hasRoleOrHigher,
  };
}
